export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热播榜单
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              全网热度排行，发现大家都在看的高分好片
            </p>
          </div>

          <div className="space-y-3 max-w-3xl mx-auto">
            {/* Rank 1 */}
            <div className="flex items-center gap-4 bg-background-100 rounded-xl p-4 group cursor-pointer hover:bg-background-200/70 transition-colors">
              <span className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center flex-shrink-0">
                <span className="text-background-50 font-bold text-lg">1</span>
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-950 whitespace-nowrap">《星际征途》</h3>
                <p className="text-xs text-foreground-500">科幻 · 2026 · IMDb 8.7</p>
              </div>
              <span className="flex items-center gap-1 text-accent-600 text-sm font-semibold whitespace-nowrap">
                <i className="ri-fire-line"></i>
                9.8分
              </span>
              <span className="hidden sm:block px-3 py-1.5 rounded-lg bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap cursor-pointer">
                立即观看
              </span>
            </div>

            {/* Rank 2 */}
            <div className="flex items-center gap-4 bg-background-100 rounded-xl p-4 group cursor-pointer hover:bg-background-200/70 transition-colors">
              <span className="w-10 h-10 rounded-lg bg-accent-500/80 flex items-center justify-center flex-shrink-0">
                <span className="text-background-50 font-bold text-lg">2</span>
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-950 whitespace-nowrap">《暗夜追踪》</h3>
                <p className="text-xs text-foreground-500">悬疑 · 2026 · 豆瓣 8.5</p>
              </div>
              <span className="flex items-center gap-1 text-accent-600 text-sm font-semibold whitespace-nowrap">
                <i className="ri-fire-line"></i>
                9.6分
              </span>
              <span className="hidden sm:block px-3 py-1.5 rounded-lg bg-background-200 text-foreground-700 text-xs font-medium whitespace-nowrap cursor-pointer">
                立即观看
              </span>
            </div>

            {/* Rank 3 */}
            <div className="flex items-center gap-4 bg-background-100 rounded-xl p-4 group cursor-pointer hover:bg-background-200/70 transition-colors">
              <span className="w-10 h-10 rounded-lg bg-accent-500/60 flex items-center justify-center flex-shrink-0">
                <span className="text-background-50 font-bold text-lg">3</span>
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-950 whitespace-nowrap">《大唐风华》</h3>
                <p className="text-xs text-foreground-500">古装 · 2026 · 豆瓣 8.9</p>
              </div>
              <span className="flex items-center gap-1 text-accent-600 text-sm font-semibold whitespace-nowrap">
                <i className="ri-fire-line"></i>
                9.5分
              </span>
              <span className="hidden sm:block px-3 py-1.5 rounded-lg bg-background-200 text-foreground-700 text-xs font-medium whitespace-nowrap cursor-pointer">
                立即观看
              </span>
            </div>

            {/* Rank 4 */}
            <div className="flex items-center gap-4 bg-background-100 rounded-xl p-4 group cursor-pointer hover:bg-background-200/70 transition-colors">
              <span className="w-10 h-10 rounded-lg bg-background-300 flex items-center justify-center flex-shrink-0">
                <span className="text-foreground-600 font-bold text-lg">4</span>
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-950 whitespace-nowrap">《欢乐一家人》</h3>
                <p className="text-xs text-foreground-500">喜剧 · 2026 · 豆瓣 8.3</p>
              </div>
              <span className="flex items-center gap-1 text-foreground-500 text-sm font-medium whitespace-nowrap">
                <i className="ri-thumb-up-line"></i>
                9.3分
              </span>
              <span className="hidden sm:block px-3 py-1.5 rounded-lg bg-background-200 text-foreground-700 text-xs font-medium whitespace-nowrap cursor-pointer">
                立即观看
              </span>
            </div>

            {/* Rank 5 */}
            <div className="flex items-center gap-4 bg-background-100 rounded-xl p-4 group cursor-pointer hover:bg-background-200/70 transition-colors">
              <span className="w-10 h-10 rounded-lg bg-background-300 flex items-center justify-center flex-shrink-0">
                <span className="text-foreground-600 font-bold text-lg">5</span>
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-950 whitespace-nowrap">《深海危机》</h3>
                <p className="text-xs text-foreground-500">灾难 · 2026 · IMDb 7.9</p>
              </div>
              <span className="flex items-center gap-1 text-foreground-500 text-sm font-medium whitespace-nowrap">
                <i className="ri-thumb-up-line"></i>
                9.1分
              </span>
              <span className="hidden sm:block px-3 py-1.5 rounded-lg bg-background-200 text-foreground-700 text-xs font-medium whitespace-nowrap cursor-pointer">
                立即观看
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}